import React from 'react';


import "./CountOn.scss";
import { Article } from '../../../elements/Article/Article';


function CountOn() {
  return (
    <Article src={"web-countOn"} className={"CountOn block wall"}/>
  );
}

export default CountOn;
